import { useParams } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import SubTreatmentDetail from "@/pages/treatment/detail/components/SubTreatmentDetail";
import SlimInjectionDetail from "@/pages/treatment/detail/components/SlimInjectionDetail";
import SlimZeroTreatmentDetail from "@/pages/treatment/detail/components/SlimZeroTreatmentDetail";
import StemSupDripDetail from "@/pages/treatment/detail/components/StemSupDripDetail";
import InjectablesSubDetail from "@/pages/treatment/detail/components/InjectablesSubDetail";
import EyeSubDetail from "@/pages/treatment/detail/components/EyeSubDetail";
import { getSubTreatmentPage } from "@/mocks/subTreatmentPages";
import { getSlimZeroDetailPage } from "@/mocks/slimZeroDetails";
import { getInjectablesDetail } from "@/mocks/injectablesPages";
import { getEyeDetail } from "@/mocks/eyePages";

export default function SubTreatmentPage({ category }: { category: string }) {
  const { slug } = useParams<{ slug: string }>();

  if (category === "slim") {
    // 新脂肪溶解注射は専用の正式コンテンツページ
    if (slug === "injection") return <SlimInjectionDetail />;

    // RF / 脂肪冷却 / 医療用EMS も正式コンテンツページ
    const slimData = slug ? getSlimZeroDetailPage(slug) : undefined;
    if (slimData) return <SlimZeroTreatmentDetail data={slimData} />;
  }

  // StemSup点滴 は専用の正式コンテンツページ（旧 dermapen-stemsup はリダイレクト）
  if (category === "regenerative" && slug === "stemsup-drip") {
    return <StemSupDripDetail />;
  }

  // 注入治療（BOTOX / ヒアルロン酸）は専用の正式コンテンツページ
  if (category === "injectables") {
    const injectablesData = slug ? getInjectablesDetail(slug) : undefined;
    if (injectablesData) return <InjectablesSubDetail data={injectablesData} />;
  }

  // 二重・目元（二重埋没法）は専用の正式コンテンツページ
  if (category === "eye") {
    const eyeData = slug ? getEyeDetail(slug) : undefined;
    if (eyeData) return <EyeSubDetail data={eyeData} />;
  }

  const data = slug ? getSubTreatmentPage(category, slug) : undefined;
  if (!data) return <NotFound />;
  return <SubTreatmentDetail data={data} />;
}